import { IDurationUnits } from '../interfaces';

class Durations {
    private durationUnits: IDurationUnits = [
        'years',
        'months',
        'weeks',
        'days',
        'hours',
        'minutes',
        'seconds',
    ];

    public setup(durationUnitsTranslations: string[]): void {
        this.durationUnits = durationUnitsTranslations;
    }

    public get units(): IDurationUnits {
        return this.durationUnits;
    }
}

export const durations = new Durations();
